<!--begin::Card-->
<div class="card">
  <!--begin::Card header-->
  <div class="card-header border-0 pt-6">
    <!--begin::Card title-->
    <div class="card-title">
      <!--begin::Search-->
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearch()"
          class="form-control form-control-solid w-250px ps-13" placeholder="Search courier managers..." />
      </div>
      <!--end::Search-->
    </div>
    <!--begin::Card title-->
    <!--begin::Card toolbar-->
    <div class="card-toolbar">
      <!--begin::Toolbar-->
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <!--begin::Filter-->
        <button type="button" class="btn btn-dark me-3 btn-sm" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>Filter
        </button>
        <!--end::Filter-->
        <!--begin::Add user-->
        <button type="button" class="btn btn-primary btn-sm" (click)="openAddModal()">
          <i class="ki-duotone ki-plus fs-2"></i>Add Courier Manager
        </button>
        <!--end::Add user-->
      </div>
      <!--end::Toolbar-->
    </div>
    <!--end::Card toolbar-->
  </div>
  <!--end::Card header-->

  <!--begin::Filters-->
  <div class="card-body py-4" *ngIf="showFiltersForm">
    <div class="row g-4">
      <!-- Search Keyword -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Keyword</label>
        <input type="text" class="form-control form-control-sm" placeholder="Enter keyword..." [(ngModel)]="filters.search">
      </div>

      <!-- Stock Number -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Stock Number</label>
        <input type="text" class="form-control form-control-sm" placeholder="Enter stock number..." [(ngModel)]="filters.stock_number">
      </div>

      <!-- Order Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Order Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.order_date_from">
      </div>

      <!-- Order Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Order Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.order_date_to">
      </div>
    </div>

    <div class="row g-4 mt-2">
      <!-- Complete Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Complete Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.complete_date_from">
      </div>

      <!-- Complete Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Complete Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.complete_date_to">
      </div>

      <!-- Surrendered Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Surrendered Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.surrendered_date_from">
      </div>

      <!-- Surrendered Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Surrendered Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.surrendered_date_to">
      </div>
    </div>

    <div class="row g-4 mt-2">
      <!-- Docs Released Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Docs Released Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.docs_released_date_from">
      </div>

      <!-- Docs Released Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Docs Released Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.docs_released_date_to">
      </div>

      <!-- Status Radio -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Status</label>
        <div class="d-flex gap-3 mt-2">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="status" id="statusPending" value="Pending" [(ngModel)]="filters.status">
            <label class="form-check-label" for="statusPending">
              Pending
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="status" id="statusCompleted" value="Completed" [(ngModel)]="filters.status">
            <label class="form-check-label" for="statusCompleted">
              Completed
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="status" id="statusAll" value="All" [(ngModel)]="filters.status">
            <label class="form-check-label" for="statusAll">
              All
            </label>
          </div>
        </div>
      </div>

      <!-- Filter Actions -->
      <div class="col-md-3 d-flex align-items-end justify-content-end">
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-danger" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply
          </button>
          <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--end::Filters-->

  <!--begin::Card body-->
  <div class="card-body py-4">
    <!--begin::Table-->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3" id="kt_table_courier_managers">
        <!--begin::Table head-->
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-100px">Stock</th>
            <th class="min-w-100px">Chassis No.</th>
            <th class="min-w-100px">Customer</th>
            <th class="min-w-100px">Request Type</th>
            <th class="min-w-100px cursor-pointer" [ngClass]="getSortClass('order_date')" (click)="onSort('order_date')">Order Date</th>
            <th class="min-w-100px">Courier</th>
            <th class="min-w-100px cursor-pointer" [ngClass]="getSortClass('surrender_date')" (click)="onSort('surrender_date')">Surrender Date</th>
            <th class="min-w-100px cursor-pointer" [ngClass]="getSortClass('docs_released_date')" (click)="onSort('docs_released_date')">Docs Released Date</th>
            <th class="min-w-100px cursor-pointer" [ngClass]="getSortClass('complete_date')" (click)="onSort('complete_date')">Complete Date</th>
            <th class="min-w-100px">Ship Type</th>
            <th class="min-w-100px">CTN Group No.</th>
            <th class="min-w-100px">Status</th>
            <th class="min-w-150px">Remarks</th>
            <th class="min-w-100px">Created By</th>
            <th class="min-w-100px">Tracking Number</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <!--end::Table head-->
        <!--begin::Table body-->
        <tbody class="text-gray-600 fw-semibold">
          <!-- Loading state -->
          <tr *ngIf="isLoading">
            <td colspan="17" class="text-center py-5">
              <div class="d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading courier managers...
              </div>
            </td>
          </tr>
          <!-- No data state -->
          <tr *ngIf="!isLoading && courierManagers.length === 0">
            <td colspan="17" class="text-center py-5">
              <div class="text-muted">No courier managers found</div>
            </td>
          </tr>
          <!-- Data rows -->
          <tr *ngFor="let courierManager of courierManagers; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="ms-5">
                  <span class="text-gray-800 text-hover-primary fs-5 fw-bold mb-1 d-block">
                    {{ courierManager.vehicle?.car_no || courierManager.stock || 'N/A' }}
                  </span>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">
                    {{ courierManager.vehicle?.name || 'N/A' }}
                  </span>
                </div>
              </div>
            </td>
            <td>{{ courierManager.vehicle.vin_no || 'N/A' }}</td>
            <td>{{ courierManager.customer_name || 'N/A' }} [{{ courierManager.customer_email || 'N/A' }}]</td>
            <td>{{ courierManager.surrender_date?"Surrender, ":""}} {{courierManager.docs_released_date?"Docs Released":""}}</td>
            <td>{{ courierManager.order_date || 'N/A' }}</td>
            <td>{{ courierManager.courier_company?.company_name || courierManager.courier_company_name || 'N/A' }}</td>
            <td>{{ courierManager.surrender_date || 'N/A' }}</td>
            <td>{{ courierManager.docs_released_date || 'N/A' }}</td>
            <td>{{ courierManager.complete_date || 'N/A' }}</td>
            <td>-</td>
            <td>-</td>
            <td>
              <div class="badge" [ngClass]="{
                         'badge-light-success': courierManager.status === 'Completed',
                         'badge-light-warning': courierManager.status === 'Pending',
                         'badge-light-danger': courierManager.status === 'Cancelled'
                       }">
                {{ courierManager.status || 'N/A' }}
              </div>
            </td>
            <td>{{ courierManager.remarks || 'N/A' }}</td>

            <td>-</td>
            <td>{{ courierManager.tracking_number || 'N/A' }}</td>

            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- View Docs Release Data Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-info"
                  (click)="openViewDocsReleaseModal(courierManager)"
                  title="View Docs Release Data"
                  *ngIf="courierManager?.docs_released_data">
                  <i class="ki-duotone ki-eye fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </i>
                </button>

                <!-- Edit Icon -->
                <button type="button" class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(courierManager)" title="Edit Courier Manager">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button type="button" class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteCourierManager(courierManager)" title="Delete Courier Manager">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>

          </tr>
        </tbody>
        <!--end::Table body-->
      </table>
    </div>
    <!--end::Table-->

    <!--begin::Pagination-->
    <app-pagination *ngIf="!isLoading && courierManagers.length > 0" [paginationInfo]="paginationInfo"
      (pageChange)="onPageChange($event)">
    </app-pagination>
    <!--end::Pagination-->
  </div>
  <!--end::Card body-->
  <!--end::Card-->

  <!-- Include the add/edit modal -->
  <app-add-edit-courier-manager (courierManagerAdded)="onCourierManagerAdded()"
    (courierManagerUpdated)="onCourierManagerUpdated()">
  </app-add-edit-courier-manager>

  <!-- Include the view docs release data modal -->
  <app-view-docs-release-data></app-view-docs-release-data>
